import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import { getCategoryById } from "@/utils/gallery";

const featured = [works[0], works[8], works[6], works[10]];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = featured.length;

  const goTo = useCallback((next: number) => {
    setIndex((next + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [total]);

  const current = featured[index];
  const category = getCategoryById(current.categoryId);

  return (
    <section className="relative h-[560px] w-full overflow-hidden md:h-[680px]" aria-label="精选作品推荐">
      {featured.map((item, i) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={item.cover}
            alt={`${item.title} - 模特${item.model}写真作品封面`}
            title={`${item.title} - ${item.model}写真作品`}
            className={`h-full w-full object-cover object-top ${i === index ? "animate-slow-zoom" : ""}`}
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-black/40" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />

      <div className="relative flex h-full w-full flex-col justify-end px-4 pb-16 md:px-8 md:pb-24">
        <div className="w-full max-w-3xl">
          <div key={current.id} className="animate-fade-up">
            <div className="mb-4 flex flex-wrap items-center gap-3">
              {category && (
                <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  {category.name}
                </span>
              )}
              <span className="text-xs tracking-[0.3em] text-white/70">FEATURED WORK</span>
            </div>
            <h1 className="text-4xl font-bold leading-tight text-white md:text-6xl">
              {current.title}
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/80 md:text-base">
              {current.description.slice(0, 78)}……
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/80">
              <span className="flex items-center gap-2">
                <i className="ri-user-star-line text-primary-300" />
                模特 {current.model}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-camera-lens-line text-primary-300" />
                摄影 {current.photographer}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-calendar-line text-primary-300" />
                {current.date}
              </span>
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${current.id}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-eye-line" />
                欣赏完整作品
              </Link>
              <Link
                to={category ? `/category/${category.id}` : "/"}
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-white/40 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10"
              >
                <i className="ri-grid-line" />
                查看更多分类
              </Link>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 right-4 flex items-center gap-5 md:right-8 md:bottom-10">
          <div className="flex items-center gap-2">
            {featured.map((item, i) => (
              <button
                key={item.id}
                type="button"
                aria-label={`切换到第${i + 1}张`}
                onClick={() => goTo(i)}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  i === index ? "w-8 bg-primary-400" : "w-3 bg-white/50 hover:bg-white/80"
                }`}
              />
            ))}
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="上一张"
              onClick={() => goTo(index - 1)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/40 text-white transition-colors hover:bg-white/10"
            >
              <i className="ri-arrow-left-s-line text-lg" />
            </button>
            <button
              type="button"
              aria-label="下一张"
              onClick={() => goTo(index + 1)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/40 text-white transition-colors hover:bg-white/10"
            >
              <i className="ri-arrow-right-s-line text-lg" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}